import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { ComponentsModule } from '@app/components/components.module';
import { PrFunnelPersonsModule } from '@app/components/pr-form/pr-funnel-persons/pr-funnel-persons.module';
import { PrCityFinderModule } from '@app/components/pr-city-finder/pr-city-finder.module';
import { SharedModule } from '@app/dashboard/shared/shared.module';
import { BoxContainerComponent } from './components/boxes/box-container/box-container.component';
import { BoxFooterComponent } from './components/boxes/box-container/box-footer/box-footer.component';
import { BoxIconComponent } from './components/boxes/box-container/box-icon/box-icon.component';
import { BoxNumberComponent } from './components/boxes/box-container/box-number/box-number.component';
import { BoxComponent } from './components/boxes/box-container/box/box.component';
import { CheckboxContainerComponent } from './components/checkbox-container/checkbox-container.component';
import { FirstSecondNamesComponent } from './components/first-second-names/first-second-names.component';
import { QuestionDescriptionComponent } from './components/question-description/question-description.component';
import { SubTitleComponent } from './components/sub-title/sub-title.component';
import { TitleComponent } from './components/title/title.component';
import { BirthInfoFormComponent } from './ea-subscription-forms/birth-info-form/birth-info-form.component';
import { EaSubscriptionFormsComponent } from './ea-subscription-forms/ea-subscription-forms.component';

import {
  NgxMaskConfig,
  NgxMaskDirective,
  NgxMaskPipe,
  provideNgxMask,
} from 'ngx-mask';
// import { AddressFormComponent } from "./ea-subscription-forms/address-form/address-form.component";
import { CdkStepperModule } from '@angular/cdk/stepper';
// import { IConfig, NgxMaskModule } from "ngx-mask";
import { ProfileBoxComponent } from './components/boxes/profile-box/profile-box.component';
import { ResidenceBoxComponent } from './components/boxes/residence-box/residence-box.component';
import { FormFooterComponent } from './components/form-footer/form-footer.component';
import { InfoComponent } from './components/info/info.component';
import { PhonesComponent } from './components/phones/phones.component';
import { ResidencesComponent } from './components/residences/residences.component';
import { ClickStopPropagationDirective } from './directives/click-stop-propagation.directive';
import { AddressFormComponent } from './ea-subscription-forms/address-form/address-form.component';
import { CustomStepperComponent } from './ea-subscription-forms/custom-stepper/custom-stepper.component';
import { DependentChildrenFormComponent } from './ea-subscription-forms/dependent-children-form/dependent-children-form.component';
import { ExistingInvestmentsFormComponent } from './ea-subscription-forms/existing-investments-form/existing-investments-form.component';
import { InvestmentDecreaseComponent } from './ea-subscription-forms/existing-investments-form/investment-decrease/investment-decrease.component';
import { FinancialKnowledge1FormComponent } from './ea-subscription-forms/financial-knowledge1-form/financial-knowledge1-form.component';
import { FinancialKnowledge2FormComponent } from './ea-subscription-forms/financial-knowledge2-form/financial-knowledge2-form.component';
import { FinancialKnowledge2Component } from './ea-subscription-forms/financial-knowledge2-form/financial-knowledge2/financial-knowledge2.component';
import { FinancialKnowledge3FormComponent } from './ea-subscription-forms/financial-knowledge3-form/financial-knowledge3-form.component';
import { FinancialKnowledge3Component } from './ea-subscription-forms/financial-knowledge3-form/financial-knowledge3/financial-knowledge3.component';
import { FinancialKnowledge4FormComponent } from './ea-subscription-forms/financial-knowledge4-form/financial-knowledge4-form.component';
import { FinancialKnowledge4Component } from './ea-subscription-forms/financial-knowledge4-form/financial-knowledge4/financial-knowledge4.component';
import { FinancialKnowledge7FormComponent } from './ea-subscription-forms/financial-knowledge7-form/financial-knowledge7-form.component';
import { FinancialKnowledge7Component } from './ea-subscription-forms/financial-knowledge7-form/financial-knowledge7/financial-knowledge7.component';
import { FinancialKnowledge8FormComponent } from './ea-subscription-forms/financial-knowledge8-form/financial-knowledge8-form.component';
import { HeritageFormComponent } from './ea-subscription-forms/heritage-form/heritage-form.component';
import { IncomeFormComponent } from './ea-subscription-forms/income-form/income-form.component';
import { InitializationContractFormComponent } from './ea-subscription-forms/initialization-contract-form/initialization-contract-form.component';
import { InvestorProfileComponent } from './ea-subscription-forms/initialization-contract-form/investor-profile/investor-profile.component';
import { ProfileSummaryComponent } from './ea-subscription-forms/initialization-contract-form/investor-profile/profile-summary/profile-summary.component';
import { SummaryDynamicProfileComponent } from './ea-subscription-forms/initialization-contract-form/investor-profile/profile-summary/summary-dynamic-profile/summary-dynamic-profile.component';
import { SummaryListComponent } from './ea-subscription-forms/initialization-contract-form/investor-profile/profile-summary/summary-list/summary-list.component';
import { SummaryRiskComponent } from './ea-subscription-forms/initialization-contract-form/investor-profile/profile-summary/summary-risk/summary-risk.component';
import { InvestmentKnowledgeFormComponent } from './ea-subscription-forms/investment-knowledge-form/investment-knowledge-form.component';
import { EaSubscriptionInvestmentKnowledgeComponent } from './ea-subscription-forms/investment-knowledge-form/investment-knowledge/investment-knowledge.component';
import { InvestmentObjectiveFormComponent } from './ea-subscription-forms/investment-objective-form/investment-objective-form.component';
import { InvestmentPeriodFormComponent } from './ea-subscription-forms/investment-period-form/investment-period-form.component';
import { MaritalStatusFormComponent } from './ea-subscription-forms/marital-status-form/marital-status-form.component';
import { OtherInfoFormComponent } from './ea-subscription-forms/other-info-form/other-info-form.component';
import { SpouseInfoFormComponent } from './ea-subscription-forms/spouse-info-form/spouse-info-form.component';
import { PhoneFormComponent } from './ea-subscription-forms/phone-form/phone-form.component';
import { PrincipalResidenceFormComponent } from './ea-subscription-forms/principal-residence-form/principal-residence-form.component';
import { ProfessionFormComponent } from './ea-subscription-forms/profession-form/profession-form.component';
import { RiskProfilSecondPartFormComponent } from './ea-subscription-forms/risk-profil-second-part-form/risk-profil-second-part-form.component';
import { RiskProfilSecondPartComponent } from './ea-subscription-forms/risk-profil-second-part-form/risk-profil-second-part/risk-profil-second-part.component';
import { RiskProfilThirdPartFormComponent } from './ea-subscription-forms/risk-profil-third-part-form/risk-profil-third-part-form.component';
import { RiskProfilThirdPartComponent } from './ea-subscription-forms/risk-profil-third-part-form/risk-profil-third-part/risk-profil-third-part.component';
import { SavingsCapacityFormComponent } from './ea-subscription-forms/savings-capacity-form/savings-capacity-form.component';
import { SavingsRateFormComponent } from './ea-subscription-forms/savings-rate-form/savings-rate-form.component';
import { SavingsRateComponent } from './ea-subscription-forms/savings-rate-form/savings-rate/savings-rate.component';
import { TaxResidencyFormComponent } from './ea-subscription-forms/tax-residency/tax-residency-form.component';
import { WealthDistributionFormComponent } from './ea-subscription-forms/wealth-distribution-form/wealth-distribution-form.component';
import { EaSubscriptionCompletedProfilePageComponent } from './subscription-pages/ea-subscription-completed-profile-page/ea-subscription-completed-profile-page.component';

import { EaSimulationPacksModule } from '@app/dashboard/sheets/shared/ea-simulation-packs/ea-simulation-packs.module';
import { EaSubscriptionFloorGuaranteeComponent } from './ea-subscription-forms/garantie-plancher/ea-subscription-floor-guarantee/ea-subscription-floor-guarantee.component';
import { GarantiePlancherComponent } from './ea-subscription-forms/garantie-plancher/garantie-plancher.component';
import { InvestFormComponent } from './ea-subscription-forms/invest-form/invest-form.component';
import { InvestTypeComponent } from './ea-subscription-forms/invest-form/invest-type/invest-type.component';
import { LifeInsurancePaymentComponent } from './ea-subscription-forms/invest-form/life-insurance-payment/life-insurance-payment.component';
import { InvestmentAllocationFormComponent } from './ea-subscription-forms/investment-allocation-form/investment-allocation-form.component';
import { IsinTableComponent } from './ea-subscription-forms/isin-table/isin-table.component';
import { EaSubscriptionOptionConfigurationComponent } from './ea-subscription-forms/option-configuration/ea-subscription-option-configuration/ea-subscription-option-configuration.component';
import { OptionConfigurationComponent } from './ea-subscription-forms/option-configuration/option-configuration.component';
import { SimulationPacksComponent } from './ea-subscription-forms/support-form/simulation-packs/simulation-packs.component';
import { SupportFormComponent } from './ea-subscription-forms/support-form/support-form.component';
import { SupportComponent } from './ea-subscription-forms/support-form/support/support.component';
import { TauxParSupportComponent } from './ea-subscription-forms/taux-par-support/taux-par-support.component';
// import { AppCtrlTemplateDirective } from "./directives/app-ctrl-template.directive";
// import { TemplatesComponent } from "./templates-component/templates-component";
// import { BottomSheetOverviewComponent } from "./subscription-overview/bottom-sheet-overview/bottom-sheet-overview.component";
// import { InvestmentAmountDurationFormComponent } from "./ea-subscription-forms/investment-amount-duration-form/investment-amount-duration-form.component";
// import { InvestmentAmountDurationComponent } from "./ea-subscription-forms/investment-amount-duration-form/investment-amount-duration/investment-amount-duration.component";
import { InvestissementProgressifTableComponent } from './ea-subscription-forms/investissement-progressif-table/investissement-progressif-table.component';
import { InvestissementSupportFormComponent } from './ea-subscription-forms/investissement-support-form/investissement-support-form.component';
// import { UserOtherNationalitiesComponent } from "./components/user-other-nationalities/user-other-nationalities.component";
// import { EaSubscriptionFinalPageComponent } from "./subscription-pages/ea-subscription-final-page/ea-subscription-final-page.component";
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import {
  MatPaginatorIntl,
  MatPaginatorModule,
} from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatTooltipModule } from '@angular/material/tooltip';
// import { SecurisationPlusValuesComponent } from "./ea-subscription-forms/securisation-plus-values-form/securisation-plus-values.component";
// import { SecurisationMoinsValuesComponent } from "./ea-subscription-forms/securisation-moins-values-form/securisation-moins-values.component";
import { SummaryREFComponent } from './ea-subscription-forms/initialization-contract-form/investor-profile/profile-summary/summary-ref/summary-ref.component';
// import { CivilStateFormComponent } from "./ea-subscription-forms/civil-state-form/civil-state-form.component";
// import { CompanyProfileFormComponent } from "./ea-subscription-forms/company/company-profile-form/company-profile-form.component";
// import { BeneficiaryClauseFormComponent } from "./ea-subscription-forms/beneficiary-clause-form/beneficiary-clause-form.component";
// import { BeneficiaryTypeComponent } from "./ea-subscription-forms/beneficiary-clause-form/beneficiary-type/beneficiary-type.component";
// import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
// import { MatDialogModule } from "@angular/material/dialog";
// import { MatDividerModule } from "@angular/material/divider";
// import { MatIconModule } from "@angular/material/icon";
// import { MatListModule } from "@angular/material/list";
// import { MatMenuModule } from "@angular/material/menu";
// import {
//   MatPaginatorIntl,
//   MatPaginatorModule,
// } from "@angular/material/paginator";
// import { MatRadioModule } from "@angular/material/radio";
// import { MatSelectModule } from "@angular/material/select";
// import { MatSliderModule } from "@angular/material/slider";
// import { MatTooltipModule } from "@angular/material/tooltip";
import { SimulationPackService } from '@app/dashboard/sheets/shared/ea-simulation-packs/simulation-pack.service';
import { BeneficiaryBoxComponent } from './components/boxes/beneficiary-box/beneficiary-box.component';
import { FundsInitialPaymentComponent } from './components/funds-initial-payment/funds-initial-payment.component';
// import { OwnerFormArrayComponent } from "./components/owner-form-array/owner-form-array.component";
import { UserOtherNationalitiesComponent } from './components/user-other-nationalities/user-other-nationalities.component';
import { AppCtrlTemplateDirective } from './directives/app-ctrl-template.directive';
import { FiscalAddressComponent } from './ea-subscription-forms/address-form/fiscal-address/fiscal-address.component';
import { OwnerAddressComponent } from './ea-subscription-forms/address-form/owner-address/owner-address.component';
import { BeneficiaryClauseFormComponent } from './ea-subscription-forms/beneficiary-clause-form/beneficiary-clause-form.component';
import { BeneficiaryClauseComponent } from './ea-subscription-forms/beneficiary-clause-form/beneficiary-clause/beneficiary-clause.component';
import { BeneficiaryDeathInsuredComponent } from './ea-subscription-forms/beneficiary-clause-form/beneficiary-death-insured/beneficiary-death-insured.component';
import { BeneficiaryTypeComponent } from './ea-subscription-forms/beneficiary-clause-form/beneficiary-type/beneficiary-type.component';
import { NotaryInfoComponent } from './ea-subscription-forms/beneficiary-clause-form/notary-info/notary-info.component';
import { CivilStateFormComponent } from './ea-subscription-forms/civil-state-form/civil-state-form.component';
import { CompanyProfileFormComponent } from './ea-subscription-forms/company/company-profile-form/company-profile-form.component';
import { DocumentFormComponent } from './ea-subscription-forms/document-form/document-form.component';
import { ElectronicSignatureFormComponent } from './ea-subscription-forms/electronic-signature-form/electronic-signature-form.component';
import { ElectronicSignatureComponent } from './ea-subscription-forms/electronic-signature-form/electronic-signature/electronic-signature.component';
// import { SubscriptionOverviewComponent } from "./subscription-overview/subscription-overview.component";
// import { DialogOwnersOverviewComponent } from "./subscription-overview/dialog-owners-overview/dialog-owners-overview.component";
import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { OwnerFormArrayComponent } from './components/owner-form-array/owner-form-array.component';
// import { MailComponent } from "./ea-subscription-forms/mail/mail.component";
// import { DialogProductssOverviewComponent } from "./subscription-overview/dialog-productss-overview/dialog-productss-overview.component";
// import { EaSubscriptionInfoComponent } from "./subscription-pages/ea-subscription-info/ea-subscription-info.component";
// import { SubscriptionInitOverviewComponent } from "./subscription-overview/subscription-init-overview/subscription-init-overview.component";
// import { ManagementMandateComponent } from "./ea-subscription-forms/support-form/management-mandate/management-mandate.component";
import { FinancialKnowledge8Component } from './ea-subscription-forms/financial-knowledge8-form/financial-knowledge8/financial-knowledge8.component';
import { FundsInitialPaymentFormComponent } from './ea-subscription-forms/funds-initial-payment-form/funds-initial-payment-form.component';
import { FundsInitialComponent } from './ea-subscription-forms/funds-initial-payment-form/funds-initial/funds-initial.component';
// import { EaSubscriptionFloorGuaranteeComponent } from "./ea-subscription-forms/garantie-plancher/ea-subscription-floor-guarantee/ea-subscription-floor-guarantee.component";
// import { GarantiePlancherComponent } from "./ea-subscription-forms/garantie-plancher/garantie-plancher.component";
import { ContractBoxComponent } from './ea-subscription-forms/initialization-contract-form/contract-box/contract-box.component';
// import { SummaryREFComponent } from "./ea-subscription-forms/initialization-contract-form/investor-profile/profile-summary/summary-ref/summary-ref.component";
// import { InvestFormComponent } from "./ea-subscription-forms/invest-form/invest-form.component";
// import { InvestTypeComponent } from "./ea-subscription-forms/invest-form/invest-type/invest-type.component";
// import { LifeInsurancePaymentComponent } from "./ea-subscription-forms/invest-form/life-insurance-payment/life-insurance-payment.component";
// import { InvestissementProgressifTableComponent } from "./ea-subscription-forms/investissement-progressif-table/investissement-progressif-table.component";
// import { InvestissementSupportFormComponent } from "./ea-subscription-forms/investissement-support-form/investissement-support-form.component";
import { DiscountIbanComponent } from './ea-subscription-forms/discount-form/discount-iban/discount-iban.component';
import { InvestissementSupportComponent } from './ea-subscription-forms/investissement-support-form/investissement-support/investissement-support.component';
import { InvestmentAllocationComponent } from './ea-subscription-forms/investment-allocation-form/investment-allocation/investment-allocation.component';
import { InvestmentAmountDurationFormComponent } from './ea-subscription-forms/investment-amount-duration-form/investment-amount-duration-form.component';
import { InvestmentAmountDurationComponent } from './ea-subscription-forms/investment-amount-duration-form/investment-amount-duration/investment-amount-duration.component';
import { InvestmentPeriodComponent } from './ea-subscription-forms/investment-period-form/investment-period/investment-period.component';
import { MailComponent } from './ea-subscription-forms/mail/mail.component';
import { CheckComponent } from './ea-subscription-forms/payment-form/check/check.component';
import { DebitComponent } from './ea-subscription-forms/payment-form/debit/debit.component';
import { PaymentFormComponent } from './ea-subscription-forms/payment-form/payment-form.component';
import { RentPaymentIbanComponent } from './ea-subscription-forms/rent-payment-iban/rent-payment-iban.component';
import { SecurisationMoinsValuesComponent } from './ea-subscription-forms/securisation-moins-values-form/securisation-moins-values.component';
import { SecurisationPlusValuesComponent } from './ea-subscription-forms/securisation-plus-values-form/securisation-plus-values.component';
import { ManagementMandateComponent } from './ea-subscription-forms/support-form/management-mandate/management-mandate.component';
import { BottomSheetOverviewComponent } from './subscription-overview/bottom-sheet-overview/bottom-sheet-overview.component';
import { DialogOwnersOverviewComponent } from './subscription-overview/dialog-owners-overview/dialog-owners-overview.component';
import { SubscriptionInitOverviewComponent } from './subscription-overview/subscription-init-overview/subscription-init-overview.component';
import { SubscriptionOverviewComponent } from './subscription-overview/subscription-overview.component';
import { EaSubscriptionFinalPageComponent } from './subscription-pages/ea-subscription-final-page/ea-subscription-final-page.component';
import { EaSubscriptionInfoComponent } from './subscription-pages/ea-subscription-info/ea-subscription-info.component';
import { TemplatesComponent } from './templates-component/templates-component';

import {
  FormContainerDirective,
  FormWizardOwnersComponent,
} from './components/form-wizard-owners/form-wizard-owners.component';
import { RangeSliderComponent } from './components/range-slider/range-slider.component';
import { JustificatifDomicileFormComponent } from './ea-subscription-forms/document-form/justificatif-domicile-form/justificatif-domicile-form.component';
import { JustificatifOrigineDesFondsFormComponent } from './ea-subscription-forms/document-form/justificatif-origine-des-fonds-form/justificatif-origine-des-fonds-form.component';
import { FeesFormComponent } from './ea-subscription-forms/fees-form/fees-form.component';
import { ProductFormComponent } from './ea-subscription-forms/product-form/product-form.component';
import { ScpiAmountComponent } from './ea-subscription-forms/product-form/scpi-amount/scpi-amount.component';
import { SCPIConfigurationComponent } from './ea-subscription-forms/product-form/scpi-configuration/scpi-configuration.component';
import { ScpiTableComponent } from './ea-subscription-forms/product-form/scpi-table/scpi-table.component';
import { SelectSCPIComponent } from './ea-subscription-forms/product-form/select-scpi/select-scpi.component';
import { SimulationPacksScpiComponent } from './ea-subscription-forms/product-form/simulation-packs-scpi/simulation-packs-scpi.component';
import { SwitcherScpiComponent } from './ea-subscription-forms/product-form/switcher-scpi/switcher-scpi.component';
import { SubscribeInLifeComponent } from './ea-subscription-forms/subscribe-in-life/subscribe-in-life.component';

import { OwnershipTypeScpiComponent } from './ea-subscription-forms/product-form/ownership-type-scpi/ownership-type-scpi.component';
import { ScpiTableEditableComponent } from './ea-subscription-forms/product-form/scpi-table-editable/scpi-table-editable.component';
import { ScpiMeansPaymentComponent } from './ea-subscription-forms/scpi-means-payment/scpi-means-payment.component';
import { ProductInitComponent } from './subscription-overview/product-init/product-init.component';

import { MatExpansionModule } from '@angular/material/expansion';
import { MatStepperModule } from '@angular/material/stepper';
import { PrSwiperModule } from '@app/components/pr-swiper/pr-swiper.module';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { BeneficiaryClauseBeneficiaireComponent } from './components/beneficiary-clause-beneficiaire/beneficiary-clause-beneficiaire.component';
import { CompanyAddressesArrayComponent } from './components/company-addresses-array/company-addresses-array.component';
import { CompanyBeneficialownerArrayComponent } from './components/company-beneficialowner-array/company-beneficialowner-array.component';
import { DistributionAssetsIncomeComponent } from './components/distribution-assets-income/distribution-assets-income.component';
import { DistributionAssetsComponent } from './components/distribution-assets/distribution-assets.component';
import { FormWrapperComponent } from './components/form-wrapper/form-wrapper.component';
import { JointOwnershipFormComponent } from './components/joint-ownership-form/joint-ownership-form.component';
import { OwnerHeaderComponent } from './components/owner-header/owner-header.component';
import { OwnersFormComponent } from './components/owners-form/owners-form.component';
import { VoiceRecognitionComponent } from './components/voice-recognition/voice-recognition.component';
import { ToFixedFormatterDirective } from './directives/to-fixed-formatter.directive';
import { EsgInvestmentListComponent } from './ea-subscription-forms/Esg/esg-investment-list/esg-investment-list.component';
import { EsgInvestmentSituationComponent } from './ea-subscription-forms/Esg/esg-investment-situation/esg-investment-situation.component';
import { EsgSituationComponent } from './ea-subscription-forms/Esg/esg-situation/esg-situation.component';
import { TaxonomyComponent } from './ea-subscription-forms/Esg/taxonomy/taxonomy.component';
import { AdditionalQuestionInvestmentComponent } from './ea-subscription-forms/additional-questions/additional-question-investment/additional-question-investment.component';
import { FinancialMarketComponent } from './ea-subscription-forms/additional-questions/financial-market/financial-market.component';
import { InvestmentHorizonComponent } from './ea-subscription-forms/additional-questions/investment-horizon/investment-horizon.component';
import { RealEstateMarketsComponent } from './ea-subscription-forms/additional-questions/real-estate-markets/real-estate-markets.component';
import { AssessmentAssetsFormComponent } from './ea-subscription-forms/assessment-assets-form/assessment-assets-form.component';
import { AssessmentAssetsComponent } from './ea-subscription-forms/assessment-assets-form/assessment-assets/assessment-assets.component';
import { AssessmentAssetsIncomeComponent } from './ea-subscription-forms/assessment-assets-incomeform/assessment-assets-income/assessment-assets-income.component';
import { AssessmentAssetsIncomeformComponent } from './ea-subscription-forms/assessment-assets-incomeform/assessment-assets-incomeform.component';
import { AssessmentAssetsOriginFormComponent } from './ea-subscription-forms/assessment-assets-originform/assessment-assets-originform.component';
import { BondAmountComponent } from './ea-subscription-forms/bond/bond-amount/bond-amount.component';
import { BondFeesComponent } from './ea-subscription-forms/bond/bond-fees/bond-fees.component';
import { BondProjectDurationComponent } from './ea-subscription-forms/bond/bond-project-duration/bond-project-duration.component';
import { CatAmountComponent } from './ea-subscription-forms/cat/cat-amount/cat-amount.component';
import { ChildrenFormComponent } from './ea-subscription-forms/children-form/children-form.component';
import { ClientAdequationFormComponent } from './ea-subscription-forms/client-adequation-form/client-adequation-form.component';
import { CodeParrainageFormComponent } from './ea-subscription-forms/code-parrainage-form/code-parrainage-form.component';
import { CompanyAddressesFormComponent } from './ea-subscription-forms/company/company-addresses-form/company-addresses-form.component';
import { CompanyBeneficialownerFormComponent } from './ea-subscription-forms/company/company-beneficialowner-form/company-beneficialowner-form.component';
import { CompanySituationComptableFormComponent } from './ea-subscription-forms/company/company-situation-comptable-form/company-situation-comptable-form.component';
import { CompteTitreAmountComponent } from './ea-subscription-forms/compte-titre/compte-titre-amount/compte-titre-amount.component';
import { CompteTitreFeesComponent } from './ea-subscription-forms/compte-titre/compte-titre-fees/compte-titre-fees.component';
import { CompteTitreProjectDurationComponent } from './ea-subscription-forms/compte-titre/compte-titre-project-duration/compte-titre-project-duration.component';
import { ContigencyGarantiesComponent } from './ea-subscription-forms/contigency/contigency-garanties/contigency-garanties.component';
import { InsuranceGarantiesComponent } from './ea-subscription-forms/insurance/insurance-garanties/insurance-garanties.component';
import { InsuranceHypothesesComponent } from './ea-subscription-forms/insurance/insurance-hypotheses/insurance-hypotheses.component';
import { InsuranceInformationsComponent } from './ea-subscription-forms/insurance/insurance-informations/insurance-informations.component';
import { ContigencyRegimeProfessionComponent } from './ea-subscription-forms/contigency/contigency-regime-profession/contigency-regime-profession.component';
import { ContigencyInformationsComponent } from './ea-subscription-forms/contigency/contigency-informations/contigency-informations.component';
import { ContigencyMaintainIncomeComponent } from './ea-subscription-forms/contigency/contigency-maintain-income/contigency-maintain-income.component';
import { ContigencyProtectLovedComponent } from './ea-subscription-forms/contigency/contigency-protect-loved/contigency-protect-loved.component';
import { SwisslifePrevoyanceComponent } from './ea-subscription-forms/contigency/swisslife-prevoyance/swisslife-prevoyance.component';
import { CorumGestionLibreFormComponent } from './ea-subscription-forms/corum/corum-gestion-libre-form/corum-gestion-libre-form.component';
import { CorumProfilesFormComponent } from './ea-subscription-forms/corum/corum-profiles-form/corum-profiles-form.component';
import { CorumVersementFormComponent } from './ea-subscription-forms/corum/corum-versement-form/corum-versement-form.component';
import { CreditAdditionnalInformationsComponent } from './ea-subscription-forms/credit-form/credit-additionnal-informations/credit-additionnal-informations.component';
import { CreditDiffereComponent } from './ea-subscription-forms/credit-form/credit-differe/credit-differe.component';
import { CreditDocumentationAssureurComponent } from './ea-subscription-forms/credit-form/credit-documentation-assureur/credit-documentation-assureur.component';
import { CreditGeneralInformationsComponent } from './ea-subscription-forms/credit-form/credit-general-informations/credit-general-informations.component';
import { CreditGuaranteesComponent } from './ea-subscription-forms/credit-form/credit-guarantees/credit-guarantees.component';
import { CreditInformationsComponent } from './ea-subscription-forms/credit-form/credit-informations/credit-informations.component';
import { CreditInsuranceQuotiteComponent } from './ea-subscription-forms/credit-form/credit-insurance-quotite/credit-insurance-quotite.component';
import { CreditManualTarificationComponent } from './ea-subscription-forms/credit-form/credit-manual-tarification/credit-manual-tarification.component';
import { CreditOptionTarificationComponent } from './ea-subscription-forms/credit-form/credit-option-tarification/credit-option-tarification.component';
import { CreditOutstandingsComponent } from './ea-subscription-forms/credit-form/credit-outstandings/credit-outstandings.component';
import { CreditOwnersProfessionDetailsComponent } from './ea-subscription-forms/credit-form/credit-owners-profession-details/credit-owners-profession-details.component';
import { CreditTarificationComponent } from './ea-subscription-forms/credit-form/credit-tarification/credit-tarification.component';
import { CrowdfundingAmountComponent } from './ea-subscription-forms/crowdfunding/crowdfunding-amount/crowdfunding-amount.component';
import { CrowdfundingFeesComponent } from './ea-subscription-forms/crowdfunding/crowdfunding-fees/crowdfunding-fees.component';
import { CrowdfundingProjectDurationComponent } from './ea-subscription-forms/crowdfunding/crowdfunding-project-duration/crowdfunding-project-duration.component';
import { CrowdfundingSettingsComponent } from './ea-subscription-forms/crowdfunding/crowdfunding-settings/crowdfunding-settings.component';
import { CrowdfundingSettings2Component } from './ea-subscription-forms/crowdfunding/crowdfunding-settings2/crowdfunding-settings2.component';
import { RiskTotalLossComponent } from './ea-subscription-forms/crowdfunding/risk-total-loss/risk-total-loss.component';
import { DiscountFormComponent } from './ea-subscription-forms/discount-form/discount-form.component';
import { DiversificationAmountComponent } from './ea-subscription-forms/diversification-investment/diversification-investment-amount/diversification-investment-amount.component';
import { DiversificationInvestmentFeesComponent } from './ea-subscription-forms/diversification-investment/diversification-investment-fees/diversification-investment-fees.component';
import { DiversificationInvestmentProjectDurationComponent } from './ea-subscription-forms/diversification-investment/diversification-investment-project-duration/diversification-investment-project-duration.component';
import { DocumentComplianceComponent } from './ea-subscription-forms/document-compliance/document-compliance.component';
import { TabsComponent } from './ea-subscription-forms/document-compliance/tabs/tabs.component';
import { AccountResultsFormComponent } from './ea-subscription-forms/document-form/account-results-form/account-results-form.component';
import { AttestationBeneficiairesEffectifsFormComponent } from './ea-subscription-forms/document-form/attestation-beneficiaires-effectifs-form/attestation-beneficiaires-effectifs-form.component';
import { BilanFormComponent } from './ea-subscription-forms/document-form/bilan-form/bilan-form.component';
import { CarteVitaleFormComponent } from './ea-subscription-forms/document-form/carte-vitale-form/carte-vitale-form.component';
import { ContratMariageFormComponent } from './ea-subscription-forms/document-form/contrat-mariage-form/contrat-mariage-form.component';
import { FamilyBookFormComponent } from './ea-subscription-forms/document-form/family-book-form/family-book-form.component';
import { FsiFormComponent } from './ea-subscription-forms/document-form/fsi-form/fsi-form.component';
import { JustificatifSituationMatrimonialeFormComponent } from './ea-subscription-forms/document-form/justificatif-situation-matrimoniale-form/justificatif-situation-matrimoniale-form.component';
import { KbisFormComponent } from './ea-subscription-forms/document-form/kbis-form/kbis-form.component';
import { OffreDePretFormComponent } from './ea-subscription-forms/document-form/offre-de-pret-form/offre-de-pret-form.component';
import { PhoneBillFormComponent } from './ea-subscription-forms/document-form/phone-bill-form/phone-bill-form.component';
import { RcsRegistrationExtractFormComponent } from './ea-subscription-forms/document-form/rcs-registration-extract/rcs-registration-extract.component';
import { RibFormComponent } from './ea-subscription-forms/document-form/rib-form/rib-form.component';
import { StatutsSocieteFormComponent } from './ea-subscription-forms/document-form/statuts-societe-form/statuts-societe-form.component';
import { DocumentVerificationComponent } from './ea-subscription-forms/document-verification/document-verification.component';
import { FroalaEditorComponent } from './ea-subscription-forms/document-verification/froala-editor/froala-editor.component';
import { DocumentDialogComponent } from './ea-subscription-forms/electronic-signature-form/document-dialog/document-dialog.component';
import { RcdaRecommendationProposalDialogComponent } from './ea-subscription-forms/rcda-recommandation/rcda-recommendation-proposal-dialog/rcda-recommendation-proposal-dialog.component';
import { ExonerationArretTravailComponent } from './ea-subscription-forms/exoneration-arret-travail/exoneration-arret-travail.component';
import { FcpiAmountComponent } from './ea-subscription-forms/fcpi/fcpi-amount/fcpi-amount.component';
import { FcpiFeesComponent } from './ea-subscription-forms/fcpi/fcpi-fees/fcpi-fees.component';
import { FcpiProjectDurationComponent } from './ea-subscription-forms/fcpi/fcpi-project-duration/fcpi-project-duration.component';
import { FcpiSettingComponent } from './ea-subscription-forms/fcpi/fcpi-setting/fcpi-setting.component';
import { FcpiSetting2Component } from './ea-subscription-forms/fcpi/fcpi-setting2/fcpi-setting2.component';
import { FcprAmountComponent } from './ea-subscription-forms/fcpr/fcpr-amount/fcpr-amount.component';
import { FcprFeesComponent } from './ea-subscription-forms/fcpr/fcpr-fees/fcpr-fees.component';
import { FipAmountComponent } from './ea-subscription-forms/fip/fip-amount/fip-amount.component';
import { FipProjectDurationComponent } from './ea-subscription-forms/fip/fip-project-duration/fip-project-duration.component';
import { FipSettingComponent } from './ea-subscription-forms/fip/fip-setting/fip-setting.component';
import { FpciAmountComponent } from './ea-subscription-forms/fpci/fpci-amount/fpci-amount.component';
import { FpciFeesComponent } from './ea-subscription-forms/fpci/fpci-fees/fpci-fees.component';
import { FpciProjectDurationComponent } from './ea-subscription-forms/fpci/fpci-project-duration/fpci-project-duration.component';
import { FundsInitialPaymentScpiFormComponent } from './ea-subscription-forms/funds-initial-payment-scpi-form/funds-initial-payment-scpi-form.component';
import { FundsInitialScpiComponent } from './ea-subscription-forms/funds-initial-payment-scpi-form/funds-initial-scpi/funds-initial-scpi.component';
import { GfiGffNbPartsComponent } from './ea-subscription-forms/gfi-gff/gfi-gff-nb-parts/gfi-gff-nb-parts.component';
import { GfvAlreadyAssociateOfProductComponent } from './ea-subscription-forms/gfv/gfv-already-associate-of-product/gfv-already-associate-of-product.component';
import { GfvNbPartsComponent } from './ea-subscription-forms/gfv/gfv-nb-parts/gfv-nb-parts.component';
import { GirardiAmountComponent } from './ea-subscription-forms/girardi-amount/girardi-amount.component';
import { CreditBoxComponent } from './ea-subscription-forms/initialization-credit-form/credit-box/credit-box.component';
import { InitializationCreditFormComponent } from './ea-subscription-forms/initialization-credit-form/initialization-credit-form.component';
import { InvestmentObjectiveHeritageComponent } from './ea-subscription-forms/investment-objective-heritage/investment-objective-heritage.component';
import { RisquesClientPersonneMoraleComponent } from './ea-subscription-forms/lcb-ft/risques-client-personne-morale/risques-client-personne-morale.component';
import { RisquesClientPersonnePhysiqueComponent } from './ea-subscription-forms/lcb-ft/risques-client-personne-physique/risques-client-personne-physique.component';
import { RisquesDistributionComponent } from './ea-subscription-forms/lcb-ft/risques-distribution/risques-distribution.component';
import { RisquesOperationsComponent } from './ea-subscription-forms/lcb-ft/risques-operations/risques-operations.component';
import { LeadCompletionSubscriptionComponent } from './ea-subscription-forms/lead-completion-subscription/lead-completion-subscription.component';
import { LifeInsuranceFeesFormComponent } from './ea-subscription-forms/life-insurance-fees-form/life-insurance-fees-form.component';
import { LmnpAmountComponent } from './ea-subscription-forms/lmnp/lmnp-amount/lmnp-amount.component';
import { LmnpSettingComponent } from './ea-subscription-forms/lmnp/lmnp-setting/lmnp-setting.component';
import { LoanRepartitionFormComponent } from './ea-subscription-forms/loan-repartition-form/loan-repartition-form.component';
import { AuditSyncActionsComponent } from './ea-subscription-forms/audit-sync-actions/audit-sync-actions.component';
import { AuditPageChoiceModalComponent } from './ea-subscription-forms/audit-sync-actions/audit-page-choice-modal/audit-page-choice-modal.component';
import { MaximumLostPercentComponent } from './ea-subscription-forms/maximum-lost-percent/maximum-lost-percent.component';
import { MoneyGamesFormComponent } from './ea-subscription-forms/money-games-form/money-games-form.component';
import { MoneyGamesComponent } from './ea-subscription-forms/money-games-form/money-games/money-games.component';
import { ObligationsAmountComponent } from './ea-subscription-forms/obligations/obligations-amount/obligations-amount.component';
import { ObligationsFeesComponent } from './ea-subscription-forms/obligations/obligations-fees/obligations-fees.component';
import { ArbitrageDisinvestmentFormComponent } from './ea-subscription-forms/operations-form/arbitrage/arbitrage-disinvestment-form/arbitrage-disinvestment-form.component';
import { ArbitrageInvestmentAllocationFormComponent } from './ea-subscription-forms/operations-form/arbitrage/arbitrage-investment-allocation-form/arbitrage-investment-allocation-form.component';
import { ArbitrageInvestmentAllocationComponent } from './ea-subscription-forms/operations-form/arbitrage/arbitrage-investment-allocation-form/arbitrage-investment-allocation/arbitrage-investment-allocation.component';
import { ArbitrageSimulationPacksComponent } from './ea-subscription-forms/operations-form/arbitrage/arbitrage-simulation-packs/arbitrage-simulation-packs.component';
import { ArbitrageReasonFormComponent } from './ea-subscription-forms/operations-form/arbitrage/arbitrage-reason-form/arbitrage-reason-form.component';
import { SupportsTableComponent } from './ea-subscription-forms/operations-form/shared/supports-table/supports-table.component';
import { ArbitrageTypeFormComponent } from './ea-subscription-forms/operations-form/arbitrage/arbitrage-type-form/arbitrage-type-form.component';
import { ReinvestmentFluxFormComponent } from './ea-subscription-forms/operations-form/arbitrage/reinvestment-flux-form/reinvestment-flux-form.component';
import { ReinvestmentStockFormComponent } from './ea-subscription-forms/operations-form/arbitrage/reinvestment-stock-form/reinvestment-stock-form.component';
import { TauxParSupportArbitrageComponent } from './ea-subscription-forms/operations-form/arbitrage/taux-par-support-arbitrage/taux-par-support-arbitrage.component';
import { RachatDisinvestmentFormComponent } from './ea-subscription-forms/operations-form/rachat/rachat-disinvestment-form/rachat-disinvestment-form.component';
import { RachatProgrammedDisinvestmentFormComponent } from './ea-subscription-forms/operations-form/rachat/rachat-disinvestment-form/rachat-programmed-disinvestment-form.component';
import { RachatProgrammedAmountFormComponent } from './ea-subscription-forms/operations-form/rachat/rachat-amount-form/rachat-programmed-amount-form.component';
import { RachatPartielTypeFormComponent } from './ea-subscription-forms/operations-form/rachat/rachat-partiel-type-form/rachat-partiel-type-form.component';
import { RachatAmountFormComponent } from './ea-subscription-forms/operations-form/rachat/rachat-amount-form/rachat-amount-form.component';
import { RachatFormComponent } from './ea-subscription-forms/operations-form/rachat/rachat-form.component';
import { ContractInformationsFormComponent } from './ea-subscription-forms/operations-form/shared/contract-informations-form/contract-informations-form.component';
import { OperationCurrentAllocationFormComponent } from './ea-subscription-forms/operations-form/shared/operation-current-allocation-form/operation-current-allocation-form.component';
import { TransferFormComponent } from './ea-subscription-forms/operations-form/transfer/transfer-form.component';
import { TransferSupportsFormComponent } from './ea-subscription-forms/operations-form/transfer/transfer-supports-form/transfer-supports-form.component';
import { TauxParSupportTransferComponent } from './ea-subscription-forms/operations-form/transfer/taux-par-support-transfer/taux-par-support-transfer.component';
import { FiscalityTypeFormComponent } from './ea-subscription-forms/operations-form/versements-libres/fiscality-type-form/fiscality-type-form.component';
import { OperationProgrammedPaymentsFrequencyFormComponent } from './ea-subscription-forms/operations-form/versements-libres/operation-programmed-payments-frequency-form/operation-programmed-payments-frequency-form.component';
import { VersementAmountFormComponent } from './ea-subscription-forms/operations-form/versements-libres/versement-amount-form/versement-amount-form.component';
import { VersementInvestmentAllocationFormComponent } from './ea-subscription-forms/operations-form/versements-libres/versement-investment-allocation-form/versement-investment-allocation-form.component';
import { VersementInvestmentAllocationComponent } from './ea-subscription-forms/operations-form/versements-libres/versement-investment-allocation-form/versement-investment-allocation/versement-investment-allocation.component';
import { VersementSimulationPacksComponent } from './ea-subscription-forms/operations-form/versements-libres/versement-simulation-packs/versement-simulation-packs.component';
import { VersementLibresSupportsFormComponent } from './ea-subscription-forms/operations-form/versements-libres/versement-libres-supports-form/versement-libres-supports-form.component';
import { TauxParSupportVersementComponent } from './ea-subscription-forms/operations-form/versements-libres/taux-par-support-versement/taux-par-support-versement.component';
import { VersementsLibresFeesFormComponent } from './ea-subscription-forms/operations-form/versements-libres/versements-libres-fees-form/versements-libres-fees-form.component';
import { OptionEpargneHandicapComponent } from './ea-subscription-forms/option-epargne-handicap/option-epargne-handicap.component';
import { OwnerTaxResidenceComponent } from './ea-subscription-forms/owner-tax-residence/owner-tax-residence.component';
import { PaymentCristalisFormComponent } from './ea-subscription-forms/payment-cristalis-form/payment-cristalis-form.component';
import { PaymentPrimesComponent } from './ea-subscription-forms/payment-primes/payment-primes.component';
import { PeaRiskAllocationLevelComponent } from './ea-subscription-forms/pea/pea-risk-allocation-level/pea-risk-allocation-level.component';
import { PeePercoFeesFormComponent } from './ea-subscription-forms/pee-perco-fees-form/pee-perco-fees-form.component';
import { PerDeductionConfigurationComponent } from './ea-subscription-forms/per/per-deduction-configuration/per-deduction-configuration.component';
import { PerEffectiveDateComponent } from './ea-subscription-forms/per/per-effective-date/per-effective-date.component';
import { PerExitConfigurationComponent } from './ea-subscription-forms/per/per-exit-configuration/per-exit-configuration.component';
import { PerOptionConfigurationComponent } from './ea-subscription-forms/per/per-option-configuration/per-option-configuration.component';
import { PerSubscriberInfoComponent } from './ea-subscription-forms/per/per-subscriber-info/per-subscriber-info.component';
import { PerTypeComponent } from './ea-subscription-forms/per/per-type/per-type.component';
import { PersonnesAChargesFormComponent } from './ea-subscription-forms/personnes-a-charges/personnes-a-charges.component';
import { PourcentageDeRemiseFormComponent } from './ea-subscription-forms/pourcentage-de-remise-form/pourcentage-de-remise-form.component';
import { PrivateEquityAmountComponent } from './ea-subscription-forms/privateEquity/private-equity-amount/private-equity-amount.component';
import { PrivateEquityFeesComponent } from './ea-subscription-forms/privateEquity/private-equity-fees/private-equity-fees.component';
import { PrivateEquityProjectDurationComponent } from './ea-subscription-forms/privateEquity/private-equity-project-duration/private-equity-project-duration.component';
import { PrivateEquityProjectTypeComponent } from './ea-subscription-forms/privateEquity/private-equity-project-type/private-equity-project-type.component';
import { DeplacementTravailHauteurFormComponent } from './ea-subscription-forms/profil-emprunteur/deplacement-travail-hauteur-form/deplacement-travail-hauteur-form.component';
import { OptionsEmprunteurComponent } from './ea-subscription-forms/profil-emprunteur/options-emprunteur-form/options-emprunteur-form.component';
import { SmokerFormComponent } from './ea-subscription-forms/profil-emprunteur/smoker-form/smoker-form.component';
import { SportDeplacementsComponent } from './ea-subscription-forms/profil-emprunteur/sport-deplacements-form/sport-deplacements-form.component';
import { TravailManuelComponent } from './ea-subscription-forms/profil-emprunteur/travail-manuel-form/travail-manuel-form.component';
import { TravailRisqueComponent } from './ea-subscription-forms/profil-emprunteur/travail-risque-form/travail-risque-form.component';
import { RcdaComparaisonProductsComponent } from './ea-subscription-forms/rcda-comparaison-products/rcda-comparaison-products.component';
import { RcdaDevisSelectionComponent } from './ea-subscription-forms/rcda-devis-selection/rcda-devis-selection.component';
import { RcdaRecommandationComponent } from './ea-subscription-forms/rcda-recommandation/rcda-recommandation.component';
import { RealEstateCharacteristicsCristalisComponent } from './ea-subscription-forms/real-estate/real-estate-characteristics-cristalis/real-estate-characteristics-cristalis.component';
import { RealEstateCharacteristicsComponent } from './ea-subscription-forms/real-estate/real-estate-characteristics/real-estate-characteristics.component';
import { RealEstateCharacteristics2Component } from './ea-subscription-forms/real-estate/real-estate-characteristics2/real-estate-characteristics2.component';
import { RealEstateCostsComponent } from './ea-subscription-forms/real-estate/real-estate-costs/real-estate-costs.component';
import { RealEstateFiscalLawComponent } from './ea-subscription-forms/real-estate/real-estate-fiscal-law/real-estate-fiscal-law.component';
import { RealEstateInvestmentAmountComponent } from './ea-subscription-forms/real-estate/real-estate-investment-amount/real-estate-investment-amount.component';
import { RealEstateLMPLMNPParametersComponent } from './ea-subscription-forms/real-estate/real-estate-lmplmnpparameters/real-estate-lmplmnpparameters.component';
import { RealEstateOwnerShipTypeComponent } from './ea-subscription-forms/real-estate/real-estate-owner-ship-type/real-estate-owner-ship-type.component';
import { RealEstatePinelParametersComponent } from './ea-subscription-forms/real-estate/real-estate-pinel-parameters/real-estate-pinel-parameters.component';
import { RealEstateRiskAversionComponent } from './ea-subscription-forms/real-estate/real-estate-risk-aversion/real-estate-risk-aversion.component';
import { RiskLevelFormComponent } from './ea-subscription-forms/risk-level-form/risk-level-form.component';
import { RiskProfilCompanyFirstPartFormComponent } from './ea-subscription-forms/risk-profil-company-form/risk-profil-company-first-part-form/risk-profil-company-first-part-form.component';
import { RiskProfilCompanyFourthPartFormComponent } from './ea-subscription-forms/risk-profil-company-form/risk-profil-company-fourth-part-form/risk-profil-company-fourth-part-form.component';
import { RiskProfilCompanySecondPartFormComponent } from './ea-subscription-forms/risk-profil-company-form/risk-profil-company-second-part-form/risk-profil-company-second-part-form.component';
import { RiskProfilCompanySecondPartComponent } from './ea-subscription-forms/risk-profil-company-form/risk-profil-company-second-part-form/risk-profil-company-second-part/risk-profil-company-second-part.component';
import { RiskProfilFifthPartFormComponent } from './ea-subscription-forms/risk-profil-fifth-part-form/risk-profil-fifth-part-form.component';
import { RiskProfilFirstPartFormComponent } from './ea-subscription-forms/risk-profil-first-part-form/risk-profil-first-part-form.component';
import { RiskProfilFourthPartFormComponent } from './ea-subscription-forms/risk-profil-fourth-part-form/risk-profil-fourth-part-form.component';
import { ScpiFinanceExperienceComponent } from './ea-subscription-forms/scpi-other-questions/scpi-perial/scpi-finance-experience/scpi-finance-experience.component';
import { ScpiFinancialInstrumentsComponent } from './ea-subscription-forms/scpi-other-questions/scpi-perial/scpi-financial-instruments/scpi-financial-instruments.component';
import { ScpiIndirectRealEstateTransactionsLastYearComponent } from './ea-subscription-forms/scpi-other-questions/scpi-perial/scpi-indirect-real-estate-transactions-last-year/scpi-indirect-real-estate-transactions-last-year.component';
import { ScpiMonetairesTransactionsLastYearComponent } from './ea-subscription-forms/scpi-other-questions/scpi-perial/scpi-monetaires-transactions-last-year/scpi-monetaires-transactions-last-year.component';
import { ScpiObligationsTransactionsLastYearComponent } from './ea-subscription-forms/scpi-other-questions/scpi-perial/scpi-obligations-transactions-last-year/scpi-obligations-transactions-last-year.component';
import { ScpiOtherTransactionsLastYearComponent } from './ea-subscription-forms/scpi-other-questions/scpi-perial/scpi-other-transactions-last-year/scpi-other-transactions-last-year.component';
import { ScpiStockTransactionsLastYearComponent } from './ea-subscription-forms/scpi-other-questions/scpi-perial/scpi-stock-transactions-last-year/scpi-stock-transactions-last-year.component';
import { ScpiStructuredProductsTransactionsLastYearComponent } from './ea-subscription-forms/scpi-other-questions/scpi-perial/scpi-structured-products-transactions-last-year/scpi-structured-products-transactions-last-year.component';
import { ScpiAverageAmountTransactionsComponent } from './ea-subscription-forms/scpi-other-questions/scpi-remake-live-GMA-essentials/scpi-average-amount-transactions/scpi-average-amount-transactions.component';
import { ScpiAverageNumberTransactionsComponent } from './ea-subscription-forms/scpi-other-questions/scpi-remake-live-GMA-essentials/scpi-average-number-transactions/scpi-average-number-transactions.component';
import { ScpiAlreadyClientOfProductComponent } from './ea-subscription-forms/scpi/scpi-already-client-of-product/scpi-already-client-of-product.component';
import { ScpiDividentComponent } from './ea-subscription-forms/scpi/scpi-divident/scpi-divident.component';
import { ScpiKnowledgeComponent } from './ea-subscription-forms/scpi/scpi-knowledge/scpi-knowledge.component';
import { ScpiPledgeOfSharesComponent } from './ea-subscription-forms/scpi/scpi-pledge-of-shares/scpi-pledge-of-shares.component';
import { ScpiScheduledPaymentComponent } from './ea-subscription-forms/scpi/scpi-scheduled-payment/scpi-scheduled-payment.component';
import { SendCompletionSubscriptionEmailComponent } from './ea-subscription-forms/send-completion-subscription-email/send-completion-subscription-email.component';
import { SendDocumentsComponent } from './ea-subscription-forms/send-documents/send-documents.component';
import { AssessmentAssetsIncomeServiceDeliveryComponent } from './ea-subscription-forms/service-delivery/assessment-assets-income-service-delivery/assessment-assets-income-service-delivery.component';
import { CardComponent } from './ea-subscription-forms/service-delivery/card/card.component';
import { CgaSituationComponent } from './ea-subscription-forms/service-delivery/cga-situation/cga-situation.component';
import { EnrollmentOfficeComponent } from './ea-subscription-forms/service-delivery/enrollment-office/enrollment-office.component';
import { FinalDateMissionCustomComponent } from './ea-subscription-forms/service-delivery/final-date-mission-custom/final-date-mission-custom.component';
import { FinalDateMissionComponent } from './ea-subscription-forms/service-delivery/final-date-mission/final-date-mission.component';
import { JointOwnershipChoiceComponent } from './ea-subscription-forms/service-delivery/joint-ownership-choice/joint-ownership-choice.component';
import { JointOwnershipListingComponent } from './ea-subscription-forms/service-delivery/joint-ownership/joint-ownership-listing/joint-ownership-listing.component';
import { JointOwnershipComponent } from './ea-subscription-forms/service-delivery/joint-ownership/joint-ownership.component';
import { MissionLegalEntityComponent } from './ea-subscription-forms/service-delivery/mission-legal-entity/mission-legal-entity.component';
import { MissionParticulierComponent } from './ea-subscription-forms/service-delivery/mission-particulier/mission-particulier.component';
import { OptionLegalEntityComponent } from './ea-subscription-forms/service-delivery/option-legal-entity/option-legal-entity.component';
import { OptionParticulierComponent } from './ea-subscription-forms/service-delivery/option-particulier/option-particulier.component';
import { PaymentFrequencyComponent } from './ea-subscription-forms/service-delivery/payment-frequency/payment-frequency.component';
import { StartDateMissionComponent } from './ea-subscription-forms/service-delivery/start-date-mission/start-date-mission.component';
import { StartDateRentComponent } from './ea-subscription-forms/service-delivery/start-date-rent/start-date-rent.component';
import { TradeDiscountComponent } from './ea-subscription-forms/service-delivery/trade-discount/trade-discount.component';
import { SwisslifeGestionFinanciereComponent } from './ea-subscription-forms/swisslife-gestion-financiere/swisslife-gestion-financiere.component';
import { SwisslifeRenonceProfilComponent } from './ea-subscription-forms/swisslife-renonce-profil/swisslife-renonce-profil.component';
import { TitresParticipatifsAmountComponent } from './ea-subscription-forms/titres-participatifs/titres-participatifs-amount/titres-participatifs-amount.component';
import { TitresParticipatifsFeesComponent } from './ea-subscription-forms/titres-participatifs/titres-participatifs-fees/titres-participatifs-fees.component';
import { TitresParticipatifsProjectDurationComponent } from './ea-subscription-forms/titres-participatifs/titres-participatifs-project-duration/titres-participatifs-project-duration.component';
import { UserNifCodeExampleComponent } from './ea-subscription-forms/user-nif-code/user-nif-code-example/user-nif-code-example.component';
import { UserNifCodeFormComponent } from './ea-subscription-forms/user-nif-code/user-nif-code-form.component';
import { DecimalPipe } from './pips/decimal.pipe';
import { OwnerSelectionComponent } from './subscription-overview/subscription-init-overview/owner-selection/owner-selection.component';
import { SubscriptionOptionsComponent } from './subscription-overview/subscription-init-overview/subscription-options/subscription-options.component';
import { SubscriptionScopeChoiceComponent } from './subscription-overview/subscription-init-overview/subscription-scope-choice/subscription-scope-choice.component';
import { PackBuilderComponent } from './ea-subscription-forms/document-verification/pack-builder/pack-builder.component';
import { PdfModalComponent } from './subscription-pages/ea-subscription-final-page/pdf-modal/pdf-modal.component';
import { EaSubscriptionFormStepper } from './subscription-pages/ea-subscription-form-stepper.component/ea-subscription-form-stepper.component';
import { StepLogoComponent } from './subscription-pages/ea-subscription-form-stepper.component/step-logo/step-logo.component';
import { MenuListComponent } from './subscription-pages/menu-list/menu-list.component';
import { CustomPaginator } from './utils/CustomPaginator';

const routes: Routes = [];

const maskConfig: Partial<NgxMaskConfig> = {
  validation: false,
};

@NgModule({
  declarations: [
    EaSubscriptionFormsComponent,
    QuestionDescriptionComponent,
    TitleComponent,
    SubTitleComponent,
    BoxComponent,
    BoxContainerComponent,
    BoxNumberComponent,
    BoxIconComponent,
    BoxFooterComponent,
    CheckboxContainerComponent,

    CivilStateFormComponent,
    CompanyProfileFormComponent,

    FirstSecondNamesComponent,
    BirthInfoFormComponent,
    AddressFormComponent,
    InfoComponent,
    TaxResidencyFormComponent,
    ResidencesComponent,
    PhoneFormComponent,
    OtherInfoFormComponent,
    MaritalStatusFormComponent,
    SpouseInfoFormComponent,
    DependentChildrenFormComponent,
    PhonesComponent,
    FormFooterComponent,
    ClickStopPropagationDirective,
    EaSubscriptionCompletedProfilePageComponent,
    ProfileBoxComponent,
    IncomeFormComponent,
    ProfessionFormComponent,
    HeritageFormComponent,
    WealthDistributionFormComponent,
    PrincipalResidenceFormComponent,
    CustomStepperComponent,
    ResidenceBoxComponent,
    SavingsCapacityFormComponent,
    InvestmentObjectiveFormComponent,
    RiskProfilFirstPartFormComponent,
    InvestmentPeriodFormComponent,
    RiskProfilSecondPartFormComponent,
    RiskProfilFifthPartFormComponent,
    InvestmentPeriodComponent,
    RiskProfilSecondPartComponent,
    RiskProfilCompanySecondPartComponent,
    RiskProfilCompanySecondPartFormComponent,
    RiskProfilCompanyFourthPartFormComponent,
    SavingsRateFormComponent,
    RiskProfilThirdPartFormComponent,
    RiskProfilFourthPartFormComponent,
    ExistingInvestmentsFormComponent,
    InvestmentKnowledgeFormComponent,
    SavingsRateComponent,
    MoneyGamesComponent,
    MoneyGamesFormComponent,
    RiskProfilThirdPartComponent,
    InvestmentDecreaseComponent,
    EaSubscriptionInvestmentKnowledgeComponent,
    FinancialKnowledge1FormComponent,
    FinancialKnowledge2FormComponent,
    FinancialKnowledge3FormComponent,
    FinancialKnowledge4FormComponent,
    FinancialKnowledge7FormComponent,
    FinancialKnowledge8FormComponent,
    FinancialKnowledge2Component,
    FinancialKnowledge3Component,
    FinancialKnowledge4Component,
    FinancialKnowledge7Component,
    FinancialKnowledge8Component,
    InitializationContractFormComponent,
    InitializationCreditFormComponent,
    RisquesOperationsComponent,
    RisquesDistributionComponent,
    RisquesClientPersonneMoraleComponent,
    RisquesClientPersonnePhysiqueComponent,
    CreditBoxComponent,
    CreditInformationsComponent,
    CreditInsuranceQuotiteComponent,
    CreditDiffereComponent,
    DocumentVerificationComponent,
    CreditGeneralInformationsComponent,
    CreditGuaranteesComponent,
    CreditOutstandingsComponent,
    CreditTarificationComponent,
    CreditManualTarificationComponent,
    CreditAdditionnalInformationsComponent,
    CreditDocumentationAssureurComponent,
    InvestorProfileComponent,
    ContractBoxComponent,
    ProfileSummaryComponent,
    SummaryDynamicProfileComponent,
    SummaryListComponent,
    SummaryRiskComponent,
    SummaryREFComponent,
    InvestFormComponent,
    InvestTypeComponent,
    LifeInsurancePaymentComponent,
    FundsInitialPaymentFormComponent,
    FundsInitialPaymentComponent,
    BeneficiaryClauseBeneficiaireComponent,
    FundsInitialComponent,
    InvestmentAllocationFormComponent,
    InvestmentAllocationComponent,
    SupportFormComponent,
    SupportComponent,
    TauxParSupportComponent,
    SimulationPacksComponent,
    IsinTableComponent,
    DiscountFormComponent,
    PerEffectiveDateComponent,
    GarantiePlancherComponent,
    ExonerationArretTravailComponent,
    SwisslifeRenonceProfilComponent,
    PersonnesAChargesFormComponent,
    EaSubscriptionFloorGuaranteeComponent,
    SwisslifeGestionFinanciereComponent,
    TransferFormComponent,
    RachatFormComponent,
    TransferSupportsFormComponent,
    TauxParSupportTransferComponent,
    CorumGestionLibreFormComponent,
    CorumVersementFormComponent,
    RiskProfilCompanyFirstPartFormComponent,
    OptionConfigurationComponent,
    EaSubscriptionOptionConfigurationComponent,
    OperationCurrentAllocationFormComponent,
    AppCtrlTemplateDirective,
    ToFixedFormatterDirective,
    TemplatesComponent,
    ArbitrageDisinvestmentFormComponent,
    ArbitrageInvestmentAllocationFormComponent,
    ArbitrageInvestmentAllocationComponent,
    ArbitrageSimulationPacksComponent,
    SupportsTableComponent,
    FiscalityTypeFormComponent,
    ReinvestmentStockFormComponent,
    ReinvestmentFluxFormComponent,
    TauxParSupportArbitrageComponent,
    VersementAmountFormComponent,
    VersementsLibresFeesFormComponent,
    VersementInvestmentAllocationFormComponent,
    VersementInvestmentAllocationComponent,
    VersementSimulationPacksComponent,
    VersementLibresSupportsFormComponent,
    TauxParSupportVersementComponent,
    ObligationsAmountComponent,
    ObligationsFeesComponent,
    BottomSheetOverviewComponent,
    InvestmentAmountDurationFormComponent,
    InvestmentAmountDurationComponent,
    InvestissementSupportFormComponent,
    InvestissementProgressifTableComponent,
    UserOtherNationalitiesComponent,
    ContractInformationsFormComponent,
    EaSubscriptionFinalPageComponent,
    SecurisationPlusValuesComponent,
    SecurisationMoinsValuesComponent,
    FroalaEditorComponent,
    ArbitrageTypeFormComponent,
    CompanySituationComptableFormComponent,
    OperationProgrammedPaymentsFrequencyFormComponent,
    ArbitrageReasonFormComponent,
    BeneficiaryClauseFormComponent,
    BeneficiaryTypeComponent,
    BeneficiaryBoxComponent,
    InvestmentHorizonComponent,
    BeneficiaryDeathInsuredComponent,
    BeneficiaryClauseComponent,
    NotaryInfoComponent,
    DocumentFormComponent,
    ElectronicSignatureFormComponent,
    ElectronicSignatureComponent,
    SubscriptionOverviewComponent,
    DialogOwnersOverviewComponent,
    OwnerFormArrayComponent,
    MailComponent,
    EaSubscriptionInfoComponent,
    SubscriptionInitOverviewComponent,
    ManagementMandateComponent,
    InvestissementSupportComponent,
    FiscalAddressComponent,
    OwnerAddressComponent,
    PaymentFormComponent,
    RentPaymentIbanComponent,
    PourcentageDeRemiseFormComponent,
    CodeParrainageFormComponent,
    DebitComponent,
    CheckComponent,
    DiscountIbanComponent,
    ProductFormComponent,
    JustificatifDomicileFormComponent,
    JustificatifOrigineDesFondsFormComponent,
    SelectSCPIComponent,
    RachatDisinvestmentFormComponent,
    RachatProgrammedDisinvestmentFormComponent,
    RachatProgrammedAmountFormComponent,
    RachatPartielTypeFormComponent,
    RachatAmountFormComponent,
    SubscribeInLifeComponent,
    RcdaComparaisonProductsComponent,
    RcdaDevisSelectionComponent,
    RcdaRecommandationComponent,
    RangeSliderComponent,
    SCPIConfigurationComponent,
    FeesFormComponent,
    SimulationPacksScpiComponent,
    SwitcherScpiComponent,
    ScpiAmountComponent,
    ScpiTableComponent,
    ScpiMeansPaymentComponent,
    ProductInitComponent,
    ScpiTableEditableComponent,
    OwnershipTypeScpiComponent,
    RiskLevelFormComponent,
    AssessmentAssetsFormComponent,
    AssessmentAssetsOriginFormComponent,
    DistributionAssetsComponent,
    AssessmentAssetsComponent,
    AssessmentAssetsIncomeformComponent,
    AssessmentAssetsIncomeComponent,
    DistributionAssetsIncomeComponent,
    FundsInitialPaymentScpiFormComponent,
    FundsInitialScpiComponent,
    SendDocumentsComponent,
    DocumentDialogComponent,
    RcdaRecommendationProposalDialogComponent,
    ClientAdequationFormComponent,
    GirardiAmountComponent,
    LifeInsuranceFeesFormComponent,
    PdfModalComponent,
    VoiceRecognitionComponent,
    PhoneBillFormComponent,
    MenuListComponent,
    PeePercoFeesFormComponent,
    EsgSituationComponent,
    CreditOwnersProfessionDetailsComponent,
    EsgInvestmentSituationComponent,
    TaxonomyComponent,
    EsgInvestmentListComponent,
    RiskTotalLossComponent,
    CompanyAddressesArrayComponent,
    CompanyAddressesFormComponent,
    CrowdfundingAmountComponent,
    CrowdfundingSettingsComponent,
    CrowdfundingSettings2Component,
    PaymentPrimesComponent,
    CrowdfundingProjectDurationComponent,
    CrowdfundingFeesComponent,
    ScpiDividentComponent,
    ScpiPledgeOfSharesComponent,
    ScpiAlreadyClientOfProductComponent,
    ScpiScheduledPaymentComponent,
    EaSubscriptionFormStepper,
    StepLogoComponent,
    PerTypeComponent,
    PerSubscriberInfoComponent,
    PerOptionConfigurationComponent,
    PerDeductionConfigurationComponent,
    PerExitConfigurationComponent,
    OptionEpargneHandicapComponent,
    ScpiKnowledgeComponent,
    OwnerHeaderComponent,
    FipAmountComponent,
    FipProjectDurationComponent,
    FipSettingComponent,
    FpciAmountComponent,
    FpciFeesComponent,
    CorumProfilesFormComponent,
    FpciProjectDurationComponent,
    BondAmountComponent,
    BondFeesComponent,
    BondProjectDurationComponent,
    DiversificationAmountComponent,
    DiversificationInvestmentFeesComponent,
    DiversificationInvestmentProjectDurationComponent,
    TitresParticipatifsAmountComponent,
    TitresParticipatifsFeesComponent,
    TitresParticipatifsProjectDurationComponent,
    CompteTitreAmountComponent,
    CompteTitreFeesComponent,
    CompteTitreProjectDurationComponent,
    FcpiAmountComponent,
    FcpiSettingComponent,
    FcpiProjectDurationComponent,
    FcprAmountComponent,
    FcprFeesComponent,
    LmnpAmountComponent,
    LmnpSettingComponent,
    FcpiFeesComponent,
    FcpiSetting2Component,
    ChildrenFormComponent,
    PrivateEquityAmountComponent,
    PrivateEquityProjectDurationComponent,
    MaximumLostPercentComponent,
    PeaRiskAllocationLevelComponent,
    OwnerTaxResidenceComponent,
    FinancialMarketComponent,
    AdditionalQuestionInvestmentComponent,
    RealEstateMarketsComponent,
    TabsComponent,
    DocumentComplianceComponent,
    CatAmountComponent,
    RibFormComponent,
    FamilyBookFormComponent,
    OffreDePretFormComponent,
    FsiFormComponent,
    KbisFormComponent,
    StatutsSocieteFormComponent,
    RcsRegistrationExtractFormComponent,
    BilanFormComponent,
    AttestationBeneficiairesEffectifsFormComponent,
    AccountResultsFormComponent,
    CompanyBeneficialownerArrayComponent,
    CompanyBeneficialownerFormComponent,
    SubscriptionOptionsComponent,
    SubscriptionScopeChoiceComponent,
    PackBuilderComponent,
    OwnerSelectionComponent,
    RealEstateCharacteristicsComponent,
    RealEstateFiscalLawComponent,
    RealEstateInvestmentAmountComponent,
    RealEstatePinelParametersComponent,
    RealEstateLMPLMNPParametersComponent,
    RealEstateRiskAversionComponent,
    RealEstateCostsComponent,
    RealEstateOwnerShipTypeComponent,
    RealEstateCharacteristics2Component,
    LoanRepartitionFormComponent,
    AuditSyncActionsComponent,
    AuditPageChoiceModalComponent,
    CreditOptionTarificationComponent,
    ScpiFinanceExperienceComponent,
    ScpiFinancialInstrumentsComponent,
    ScpiStockTransactionsLastYearComponent,
    ScpiObligationsTransactionsLastYearComponent,
    ScpiMonetairesTransactionsLastYearComponent,
    ScpiStructuredProductsTransactionsLastYearComponent,
    ScpiIndirectRealEstateTransactionsLastYearComponent,
    ScpiOtherTransactionsLastYearComponent,
    ScpiAverageAmountTransactionsComponent,
    ScpiAverageNumberTransactionsComponent,
    OwnersFormComponent,
    ContratMariageFormComponent,
    DecimalPipe,
    GfvAlreadyAssociateOfProductComponent,
    GfvNbPartsComponent,
    ContigencyProtectLovedComponent,
    ContigencyMaintainIncomeComponent,
    GfiGffNbPartsComponent,
    SwisslifePrevoyanceComponent,
    ContigencyGarantiesComponent,
    InsuranceGarantiesComponent,
    InsuranceHypothesesComponent,
    InsuranceInformationsComponent,
    ContigencyRegimeProfessionComponent,
    ContigencyInformationsComponent,
    CarteVitaleFormComponent,
    JustificatifSituationMatrimonialeFormComponent,
    PrivateEquityFeesComponent,
    MissionParticulierComponent,
    MissionLegalEntityComponent,
    OptionParticulierComponent,
    CardComponent,
    CgaSituationComponent,
    TradeDiscountComponent,
    InvestmentObjectiveHeritageComponent,
    FormWrapperComponent,
    OptionLegalEntityComponent,
    PaymentFrequencyComponent,
    AssessmentAssetsIncomeServiceDeliveryComponent,
    PrivateEquityProjectTypeComponent,
    StartDateRentComponent,
    FinalDateMissionComponent,
    FinalDateMissionCustomComponent,
    JointOwnershipChoiceComponent,
    JointOwnershipComponent,
    JointOwnershipFormComponent,
    JointOwnershipListingComponent,
    EnrollmentOfficeComponent,
    UserNifCodeFormComponent,
    LeadCompletionSubscriptionComponent,
    StartDateMissionComponent,
    PaymentCristalisFormComponent,
    SendCompletionSubscriptionEmailComponent,
    UserNifCodeExampleComponent,
    SmokerFormComponent,
    DeplacementTravailHauteurFormComponent,
    TravailManuelComponent,
    TravailRisqueComponent,
    SportDeplacementsComponent,
    OptionsEmprunteurComponent,
    RealEstateCharacteristicsCristalisComponent,
    FormWizardOwnersComponent,
    FormContainerDirective,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
    PrFunnelPersonsModule,
    PrCityFinderModule,
    RouterModule.forChild(routes),
    SharedModule,
    MatSelectModule,
    // NgxMaskModule.forRoot(maskConfig),
    NgxMaskDirective,
    NgxMaskPipe,
    CdkStepperModule,
    MatSliderModule,
    MatDividerModule,
    MatListModule,
    MatPaginatorModule,
    EaSimulationPacksModule,
    MatBottomSheetModule,
    MatDialogModule,
    MatRadioModule,
    PrSwiperModule,
    MatStepperModule,
    MatMenuModule,
    MatIconModule,
    MatTooltipModule,
    MatExpansionModule,
    FroalaEditorModule,
    FroalaViewModule,
  ],
  exports: [EaSubscriptionFormsComponent],
  providers: [
    SimulationPackService,
    { provide: MatPaginatorIntl, useValue: CustomPaginator() },
    provideNgxMask(maskConfig),
  ],
})
export class SubscriptionModule {}
